import { createFileRoute } from '@tanstack/react-router';
import Caps from 'src/pages/Organization/Branches/Caps';

export const Route = createFileRoute(
  '/$organizationSlug/branches/$branchId/caps',
)({
  component: Caps,
});
